/**
 * @file ThemeToggle.tsx
 * @description
 * -----------------------------------------------------
 * Boton para cambiar de tema
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-07-16
 * @modified 2025-07-22
 * @author DLTCode
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
import { useId } from "react";
import ToggleComponent from "@/components/ui/ToggleComponent";
import { useTranslations } from "next-intl";
import { useTheme } from "@/features/theme";
export default function ThemeToggle() {
  const $ = _c(8);
  const t = useTranslations("ToggleComponent");
  const {
    theme,
    toggleTheme
  } = useTheme();
  const isDarkMode = theme === "dark";
  const uniqueId = useId();
  const themeToggleId = `theme-toggle-${uniqueId}`;
  let t0;
  if ($[0] !== isDarkMode || $[1] !== t) {
    t0 = isDarkMode ? t("darkMode") : t("lightMode");
    $[0] = isDarkMode;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== isDarkMode || $[4] !== t0 || $[5] !== themeToggleId || $[6] !== toggleTheme) {
    t1 = <ToggleComponent id={themeToggleId} name="theme" label={t0} ariaLabelKey="theme" hideLabel={true} className="theme-toggle" onChange={toggleTheme} checked={isDarkMode} />;
    $[3] = isDarkMode;
    $[4] = t0;
    $[5] = themeToggleId;
    $[6] = toggleTheme;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}